import { withTranslation } from 'react-i18next';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar } from 'reactstrap';
import { reduxForm, Field } from 'redux-form';
import SmartCard from '../../../shared/components/SmartCard';
import renderField from '../../../shared/components/form/RenderField';
import validate from './Validate';

const ChangeMyPassForm = (props) => {
  const { t, handleSubmit } = props;

  return (
    <SmartCard title={t('change_my_pass.title')}>
      <Fragment>
        <form className="form" onSubmit={handleSubmit}>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('change_my_pass.currentPass')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="currentPass"
                type="password"
                component={renderField}
                maxLength="200"
                placeholder={t('change_my_pass.currentPass')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('change_my_pass.newPass')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="newPass"
                type="password"
                component={renderField}
                maxLength="200"
                placeholder={t('change_my_pass.newPass')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('change_my_pass.confirmPass')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="confirmPass"
                type="password"
                component={renderField}
                maxLength="200"
                placeholder={t('change_my_pass.confirmPass')}
              />
            </div>
          </div>
          <ButtonToolbar className="form__button-toolbar">
            <Button color="success" type="submit">
              {t('change_my_pass.changePass')}
            </Button>
          </ButtonToolbar>
        </form>
      </Fragment>
    </SmartCard>
  );
};

ChangeMyPassForm.propTypes = {
  t: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'ChangeMyPassForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(
  withTranslation('common')(
    connect((state) => ({
      loading: state.loading,
    }))(ChangeMyPassForm)
  )
);
